import styled from 'styled-components'
import { device } from '../Breakpoints'

const Container = styled.div`
  .arrow {
      bottom: 48% !important;
      position: absolute;
      background: #8e8fc7;
      display: block;
      z-index: 9000;
      color: #ffffff;
      text-align: center;
      font-size: 1.5em;
      border: none;
      padding: 0 6px;
      min-height: 41px;
      display: flex;
      align-items: center;
      cursor: pointer;
      :hover {
        background: #c3c3c3;
      }
    }
    .next{ right:0}
    .prev{ left:0}
    .slick-slide {
      opacity: 0.5;
      text-align:center;
      img {
        width: auto;
        height: 400px;
        margin: auto;
      }
    }

    .slick-active {
      opacity: 1;
      p {
        display: block;
      }
    }
    .slick-prev {
      left: 0px !important;
      z-index: 9999;
      width: 50px;
    }
    
    
  }
  @media ${device.mobileL} {
    img {
      width: 100% !important;
    }
  }
  .slick-dots {
    bottom: -70px !important;

    li button {
      font-size: 0.6em;
      color: #8e8fc7;
      background: #ffffff;
      display: block;
      padding: 3px;
      :before {
        content: '';
      }
    }
    .slick-active button {
      color: #ffffff;
      background: #8e8fc7;
    }
  }
`

export default Container
